// Catalog API data returned as string should be converted to number.
export const catalogNumericFields = [
	'price',
	'price_custom',
	'basic_price',
	'basic_price_custom',
	'price_b2b',
	'price_b2b_custom',
	'return_fee',
	'discount',
	'discount_custom',
	'price_with_shipping',
	'extra_price_dynamicprice',
	'extra_price_cart_dynamicprice',
	'coupon_price',
	'discount_percent_custom',
	'discount_percent',
	'shipping_min_price',
	'price_custom_prices_cart',
	'price_custom_prices_cart_category',
	'price_custom_prices_cart_expire',
	'price_custom_prices_cart_shopping_cart_code',
	'tax',
	'package_qty',
	'available_qty',
	'limited_qty',
	'total_images',
];

export function convertCatalogNumericFields(item) {
	if (!item || typeof item !== 'object') return item;

	Object.entries(item).forEach(([key, value]) => {
		if (catalogNumericFields.includes(key)) item[key] = Number(value);
	});

	return item;
}
